module.exports = __webpack_public_path__ + "img/ic_linked_circle.ad57535b.svg";